import { P } from "AbstractElements";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { AlertCircle, Zap } from "react-feather";

// Modal konfirmasi mulai audit AI.
const StartAuditModal = ({ isOpen, isStarting, onCancel, onConfirm }) => {
  return (
    <Modal isOpen={isOpen} size="md" centered toggle={onCancel}>
      <ModalHeader toggle={onCancel} className="border-0 pb-0">
        <div className="d-flex align-items-center gap-2">
          <span className="rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: 36, height: 36, background: "#e0f2fe" }}>
            <Zap size={16} color="#0369a1" />
          </span>
          <span>Konfirmasi Audit AI</span>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="rounded-4 border border-primary-subtle bg-primary-subtle p-3">
          <P className="mb-0">
            Apakah Anda yakin ingin memulai audit AI untuk tryout ini? Proses berjalan di server dan hasil akan muncul setelah selesai.
          </P>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel} disabled={isStarting}>
          Batal
        </Button>
        <Button color="primary" onClick={onConfirm} disabled={isStarting}>
          {isStarting ? "Memulai..." : "Ya, Mulai"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

// Modal konfirmasi Selesaikan / Buka Kembali satu hasil audit.
const SolveConfirmModal = ({ solveConfirm, solvingIds, onCancel, onConfirm }) => {
  const item = solveConfirm.item;
  return (
    <Modal isOpen={!!item} size="sm" centered toggle={onCancel}>
      <ModalHeader toggle={onCancel} className="border-0 pb-0">
        <div className="d-flex align-items-center gap-2">
          <span className="rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: 36, height: 36, background: "#fef3c7" }}>
            <AlertCircle size={16} color="#b45309" />
          </span>
          <span>{solveConfirm.isSolving ? "Konfirmasi Selesaikan" : "Konfirmasi Buka Kembali"}</span>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="rounded-4 border border-warning-subtle bg-warning-subtle p-3">
          <P className="mb-0">
            Yakin ingin menandai <strong>{item?.question?.title ?? "soal ini"}</strong>{" "}
            sebagai {solveConfirm.isSolving ? "Selesai" : "Buka Kembali"}?
          </P>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel} disabled={solvingIds.has(item?.id)}>
          Batal
        </Button>
        <Button color={solveConfirm.isSolving ? "success" : "warning"} onClick={onConfirm} disabled={solvingIds.has(item?.id)}>
          {solvingIds.has(item?.id)
            ? "Memproses..."
            : solveConfirm.isSolving
              ? "Ya, Selesaikan"
              : "Ya, Buka Kembali"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

// Modal konfirmasi re-audit (hapus hasil lama).
const ReauditConfirmModal = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <Modal isOpen={isOpen} size="md" centered toggle={onCancel}>
      <ModalHeader toggle={onCancel} className="border-0 pb-0">
        <div className="d-flex align-items-center gap-2">
          <span className="rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: 36, height: 36, background: "#fef3c7" }}>
            <AlertCircle size={16} color="#b45309" />
          </span>
          <span>Konfirmasi Audit Ulang</span>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="rounded-4 border border-warning-subtle bg-warning-subtle p-3">
          <P className="mb-0">
            Apakah Anda yakin ingin memulai audit ulang? Hasil audit sebelumnya akan <strong>dihapus permanen</strong>.
          </P>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel}>
          Batal
        </Button>
        <Button color="primary" onClick={onConfirm}>
          Ya, Mulai Audit Ulang
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export { StartAuditModal, SolveConfirmModal, ReauditConfirmModal };
